import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import _ from 'underscore';

export const MODULE_NAME = 'OPEN_RETURNS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}
const UNLOAD = namespaced('UNLOAD');
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_VAT_BOOKS_OK = namespaced('LOAD_VAT_BOOKS_OK');

export const ACTION_TYPES = {
  UNLOAD,
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  LOAD_VAT_BOOKS_OK
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action={}) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case UNLOAD:
        return  Object.assign({}, state, {vatBooks: undefined, data: undefined, error: null});
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      case LOAD_VAT_BOOKS_OK:
        return Object.assign({}, state, {vatBooks: action.response, loading: false, error: null});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doUnload: () => {
    return (dispatch, getState) => {
      dispatch({type: UNLOAD});
    };
  },
  doLoad: (filterParams) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad(): filterParams: ', filterParams);

      return CLIENT.getOpenReturns(filterParams)
        .then((response) => {
          log.debug('doLoad(): response: ', response);
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          log.debug('doLoad(): error: ', error);
          dispatch({type: LOAD_FAIL, error: error});
        });
    };
  },

  getOpenReturnsGroupedByCountryCode: (openReturns)  => {
    log.debug('getOpenReturnsGroupedByCountryCode(): openReturns: ', openReturns);
    if (!openReturns || !_.isArray(openReturns)) {
      return {};
    }
    return openReturns.reduce((group, openReturn) => {
      group[openReturn.countryCode] = group[openReturn.countryCode] || [];
      group[openReturn.countryCode].push(openReturn);
      return group;
    }, {});
  },

  doGetVATBooks: (params) => {
    return (dispatch, getState) => {
        dispatch({type: LOAD});
        log.debug('doGetVATBooks(): params: ', params);

        return CLIENT.getVATBooks(params)
          .then((response) => {
              dispatch({type: LOAD_VAT_BOOKS_OK, response: response});
          })
          .catch((error) => {
              dispatch({type: LOAD_FAIL, error: error});
          });
    };
  }
};

export default API;
